module.exports = __webpack_public_path__ + "a3dfc27ed4c1f258008f6e281a8f07f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00000CS9.png
// module id = 1425
// module chunks = 0